import React, { cloneElement, Children, Component } from "react";
import PropTypes from "prop-types";
import throttle from "lodash/throttle";

class Gallery360 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentSlide: 0,
      userEnabled: false,
    };

    this.throttledHandleMove = throttle(this.handleMove, 100, {
      trailing: false,
    });
  }

  enableGallery = () => {
    this.setState({
      userEnabled: true,
    });
  };

  handleMove = (event) => {
    event.preventDefault();

    const pointerPosition = this.calculatePointerPosition(event);
    const max = event.currentTarget.offsetWidth;
    const offset = pointerPosition - this.state.currentSlide;
    const delta = Math.floor((offset / max) * this.props.children.length);

    // Prevent negative slide
    const newSlide = delta > 0 ? delta : 0;

    if (this.state.currentSlide !== newSlide) {
      this.setState({
        currentSlide: newSlide,
      });
    }
  };

  calculatePointerPosition(event) {
    const { clientX } =
      event.type.indexOf("touch") === 0 ? event.changedTouches[0] : event;

    const position = clientX - event.currentTarget.offsetLeft;

    // Prevent negative position
    return position > 0 ? position : 0;
  }

  render() {
    if (Array.isArray(this.props.children) && this.props.children.length > 0) {
      // 360 not enabled
      if (!this.state.userEnabled) {
        return (
          <div
            className={`${
              this.props.className || ""
            } u-position-relative u-text-align-center`}
            onClick={this.enableGallery}
          >
            <div className="rollerblade-icon"></div>
            {this.props.children[0]}
          </div>
        );
      }

      // 360 enabled
      return (
        <div
          onTouchMove={this.throttledHandleMove}
          onMouseMove={this.throttledHandleMove}
          className={`${
            this.props.className || ""
          } u-position-relative u-text-align-center gallery360`}
        >
          {Children.map(this.props.children, (child, index) =>
            cloneElement(child, {
              className: "gallery360-image",
              style: {
                display: this.state.currentSlide === index ? "block" : "none",
              },
            })
          )}

          <style jsx>{`
            :global(.gallery360-image) {
              margin: 0 auto;
            }
          `}</style>
        </div>
      );
    }

    return null;
  }
}

Gallery360.propTypes = {
  className: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
};

export default Gallery360;
